import { axiosInstance } from "api/axios.instance"

class ObjectsCategoriesClass {
	static BASE_URL = "/categories"

	async getObjectsCategories(filters: { filterAtomic?: boolean } = {}) {
		const params = new URLSearchParams()
		if (filters.filterAtomic) {
			params.append("filter", "atomic")
		}
		return axiosInstance.get(`${ObjectsCategoriesClass.BASE_URL}/`, {
			params,
		})
	}

	async includeInProcessing(includedInProcessing: boolean, categoryId: number) {
		return axiosInstance.patch(`${ObjectsCategoriesClass.BASE_URL}/${categoryId}/usedInProcessingStatus`, {
			status: includedInProcessing,
		})
	}

	async createSimpleCategory(name: string, label: string, superCategory: string, modelNumbers: number[]) {
		return axiosInstance.post(`${ObjectsCategoriesClass.BASE_URL}/simple/`, {
			name,
			label,
			super_category_name: superCategory,
			model_numbers: modelNumbers,
		})
	}

	async createDualCategory(
		name: string,
		label: string,
		topLvelCategory: string,
		superCategory: string,
		leftModelNumbers: number[],
		rightModelNumbers: number[],
		wholeModelNumbers: number[],
	) {
		return axiosInstance.post(`${ObjectsCategoriesClass.BASE_URL}/dual_object/`, {
			base_name: name,
			base_label: label,
			top_level_category_name: topLvelCategory,
			super_category_name: superCategory,
			left_cat_model_numbers: leftModelNumbers,
			right_cat_model_numbers: rightModelNumbers,
			whole_cat_model_numbers: wholeModelNumbers,
		})
	}

	async createCompositeCategory(
		name: string,
		label: string,
		superCategory: string,
		modelNumbers: number[],
		variants: { [combinationId: string]: number[][] },
	) {
		return axiosInstance.post(`${ObjectsCategoriesClass.BASE_URL}/composite/`, {
			name,
			label,
			super_category_name: superCategory,
			model_numbers: modelNumbers,
			variants,
			recipes: variants,
		})
	}

	async createColumnBasedCategory(
		name: string,
		label: string,
		superCategory: string,
		minColumns: number,
		maxColumns: number,
		modelNumbers: { [objectPosition: string]: number[] },
	) {
		return axiosInstance.post(`${ObjectsCategoriesClass.BASE_URL}/column_based/`, {
			name,
			super_category_name: superCategory,
			base_label: label,
			min_columns: minColumns,
			max_columns: maxColumns,
			model_numbers: modelNumbers,
		})
	}

	async updateModelNumbers(categoryId: number, modelNumberIds: number[]) {
		return axiosInstance.patch(`${ObjectsCategoriesClass.BASE_URL}/${categoryId}/model-numbers/`, modelNumberIds)
	}

	async deleteCategory(id: number | undefined) {
		return axiosInstance.delete(`${ObjectsCategoriesClass.BASE_URL}/${id}`)
	}
}

export default new ObjectsCategoriesClass()
